export const VENTILATION_OPTIONS = [
    {
        label: "exhaust from the zone to outside",
        value: "outsideExhaust",
    },
    {
        label: "supply from the outside",
        value: "outsideSupply",
    },
    {
        label: "both supply from and exhaust to the outside",
        value: "outsideSupplyAndExhaust",
    },
    {
        label: "supply from a central air handling system",
        value: "centralSupply",
    },
    {
        label: "return to a central air handling system",
        value: "centralReturn",
    },
    {
        label: "both supply from and return to a central air handling system",
        value: "centralSupplyAndReturn",
    },
];

export const CENTRAL_EQUIP_TYPES = [0, 1];